import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Header, Grid, Accordion, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import  styles  from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const CompanionLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0]);

  const renderAccordionConsiderations = () => {
    return (
      <>       
        <Message info floating className={styles.learnMoreMsg}>
          <Header icon style={{display:"grid"}}> 
            <Image src={`${iconRoute}AnimalPaw.svg`} className={styles.learnMoreMsgHeaderIcon} />
            <p className={styles.learnMoreMsgHeader}>Getting a pet is a major decision.</p>
            <Header.Content className={styles.learnMoreMsgContent}>
            You will want to have a serious discussion with the older adult to consider whether a companion animal is right for them, and, if so, what kind.
            </Header.Content>
          </Header>
        </Message>
        <Grid stackable className={styles.learnMoreFullDiv} >
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}MoneyIcon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >AFFORDABILITY </p>
                  <Header.Subheader>
                    <p className={styles.highlightsItemHeaderQuestion} > Can they afford a companion animal?</p>
                    <p className={styles.learnMoreAccordionText} > 
                      The cost of owning a pet can have an impact on finances, especially for those on a fixed 
                      income. You will want to estimate the monthly and yearly costs for food, grooming, vet visits, 
                      and other things associated with pet care. It is also a good idea to look into pet insurance 
                      to help cover unexpected costs. </p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}homeHouseAnimalsVet.svg`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >HOUSING</p>
                  <Header.Subheader> 
                    <p className={styles.highlightsItemHeaderQuestion} > Does their housing situation allow for a pet?</p> 
                    <p className={styles.learnMoreAccordionText} >
                      If the older adult is renting their residence, check with the landlord to see what their policy is
                      for animals. If there is a plan for assisted-living facilities in the future, check to see if they allow pets 
                      or research facilities that do. Some dogs may require more space than other pets.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
          <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`}>
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}SeniorWalkingDog2.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconEnlarge}`} />
                  <p className={styles.highlightsItemHeaderTitle} >ACTIVITY LEVELS</p>
                  <Header.Subheader>  
                    <p className={styles.highlightsItemHeaderQuestion} > What type of animal is best for their activity level? </p>
                    <p className={styles.learnMoreAccordionText} >
                      A cat might be a better option than a dog for someone who has mobility issues since they do not 
                      require daily walks. Adopting an older animal is also a great idea since they typically will have 
                      lower energy levels and will likely already be trained.</p> 
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
            <Grid.Column stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`}>
              <Segment raised className={styles.highlightsItemWhiteBG} >  
                <Header as='h2' icon className={styles.highlightsItemHeader} >
                  <Image src={`${iconRoute}Support2Icon.png`} className={styles.highlightsItemHeaderImgIcon} />
                  <p className={styles.highlightsItemHeaderTitle} >BACK-UP PLAN</p> 
                  <Header.Subheader> 
                    <p className={styles.highlightsItemHeaderQuestion} > Who can take over care of the animal if needed?</p>
                    <p className={styles.learnMoreAccordionText} >
                    There is a very real possibility that the older adult's health may decline, and they will not be able to care for their pet or that their pet will outlive them. It is important to consider who would be willing to take over the animal's care.</p>
                  </Header.Subheader>
                </Header>
              </Segment>  
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'considerations',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Things to Consider Before Getting a Pet </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionConsiderations()}/>)
      }
    }
  ];

  return (
    <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}CompanionInfoOne.jpg)`, }}>
      <div className={styles.learnMoreModalContent}>

        <div className={styles.learnMoreAccordionFullDivGrid} >
          <div className={styles.learnMoreAccordionFullDiv} >
            <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
          </div> 
        </div> 
        
      </div>
    </Segment>   
  );
};

export default observer(CompanionLearnMore);
